import { GALLERY_CONSTS } from 'pro-gallery-lib';
import lineHeightFixer from '../texts/LineHeightFixer';
export default function tryFixLineHeight(masterInfoConfig, currentContainer) {
    var p = masterInfoConfig;
    var _a = GALLERY_CONSTS.placements, SHOW_ON_HOVER = _a.SHOW_ON_HOVER, SHOW_BELOW = _a.SHOW_BELOW;
    var optionsForFixer = {
        galleryLayout: 'NOT_SLIDESHOW',
        allowTitle: p.enabled.Title,
        allowSocial: p.enabled.Social,
        loveButton: p.enabled.Social,
        allowDownload: p.enabled.Social,
        allowDescription: p.enabled.Description,
        titleDescriptionSpace: p.titleParams.paddingBottom,
        titlePlacement: p.masterType === 'internal' ? SHOW_ON_HOVER : SHOW_BELOW
        /* titlePlacement: 'SOMETHING_WITHOUT_COMMAS' // bug in lineHeightFixer that is splitting commas instead of underscores. */
    };
    var propsForLineHeight = {
        isNewInfoElements: true,
        options: optionsForFixer,
        title: p.titleParams.title,
        description: p.descriptionParams.description
    };
    return lineHeightFixer.fix(propsForLineHeight, currentContainer);
}
//# sourceMappingURL=tryLineHeightFixer.js.map